import { getWithToken } from './http-client';

export default {
  obtenerDatosPagos(referenciaId, token) {
    return getWithToken(
      `${process.env.RAZZLE_GATEWAY_MUNDIGEA}/pagos/obtener-pago/${referenciaId}`,
      token,
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error(error);
      });
  },
  obtenerCanalesPagoAplicacion(token) {
    return getWithToken(`${process.env.RAZZLE_GATEWAY_MUNDIGEA}/pagos/aplicacion/canales`, token)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
